import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { VILLAGE_LIST, VILLAGE_CHANGE_STATUS, VILLAGE_ADDEDIT, VILLAGE_DELETE } from "../../api/constApi";
import { VillageListApi, villageChangeStatusApi, AddEditVillageApi, villageDeleteApi } from "../Services/villageService";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const villageList = createAsyncThunk(VILLAGE_LIST, async (payload) => {
    const response = await VillageListApi(payload);
    return response.data;
});

export const villageChangeStatus = createAsyncThunk(VILLAGE_CHANGE_STATUS, async (payload) => {
    const response = await villageChangeStatusApi(payload);
    return response.data;
});

export const addEditVillage = createAsyncThunk(VILLAGE_ADDEDIT, async (payload) => {
    const response = await AddEditVillageApi(payload);
    return response.data;
});

export const deleteVillage = createAsyncThunk(VILLAGE_DELETE, async (payload) => {
    const response = await villageDeleteApi(payload);
    return response.data;
});



export const villageSlice = createSlice({
    name: "village",
    initialState: {
        village: null,
        token: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(villageList.fulfilled, (state, action) => {
            state.village = action?.payload;
        });
        builder.addCase(addEditVillage.fulfilled, (state, action) => {
            state.village = action?.payload?.Data;
          });
    }
});

export default villageSlice.reducer;

// villagelist selector
export const selectVillageList = (state) => state?.village?.village;
export const useVillageList = () => {
  const village = useSelector(selectVillageList);
  return useMemo(() => village, [village]);
};